/* global axios */

/**
 * API Client para Whitelabel SuperAdmin
 * Endpoints: /super_admin/whitelabel/*
 */

const BASE_URL = '/super_admin/whitelabel';

export default {
  /**
   * Obtém configuração atual do whitelabel
   */
  getConfig() {
    return axios.get(BASE_URL);
  },

  /**
   * Salva scripts do whitelabel
   * @param {string} scripts - HTML com scripts (style/script tags)
   */
  saveScripts(scripts) {
    return axios.post(BASE_URL, {
      whitelabel_scripts: scripts,
    });
  },

  /**
   * Lista backups disponíveis
   */
  getBackups() {
    return axios.get(`${BASE_URL}/backups`);
  },

  /**
   * Restaura backup específico
   * @param {string} timestamp - Timestamp do backup
   */
  restoreBackup(timestamp) {
    return axios.post(`${BASE_URL}/restore_backup`, { timestamp });
  },

  /**
   * Analisa script com AI
   * @param {string} scriptContent - Conteúdo do script
   */
  analyzeScript(scriptContent) {
    return axios.post(`${BASE_URL}/analyze_script`, {
      script_content: scriptContent,
    });
  },

  /**
   * Testa conexão com AI provider
   * @param {string} apiKey - API key para testar
   * @param {string} model - Modelo AI selecionado
   */
  testAiConnection(apiKey, model) {
    return axios.post(`${BASE_URL}/test_ai_connection`, {
      api_key: apiKey,
      model,
    });
  },

  /**
   * Atualiza configuração de AI
   * @param {string} apiKey - API key do provider
   * @param {string} model - Modelo AI selecionado
   */
  updateAiConfig(apiKey, model) {
    return axios.post(`${BASE_URL}/update_ai_config`, {
      api_key: apiKey,
      model,
    });
  },

  /**
   * Exporta scripts como JSON
   */
  exportScripts() {
    return axios.post(
      `${BASE_URL}/export_scripts`,
      {},
      {
        responseType: 'blob',
      }
    );
  },

  /**
   * Importa scripts de arquivo JSON
   * @param {File} file - Arquivo JSON
   */
  importScripts(file) {
    const formData = new FormData();
    formData.append('scripts_file', file);
    return axios.post(`${BASE_URL}/import_scripts`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  /**
   * Obtém diff entre versão atual e backup
   * @param {string} timestamp - Timestamp do backup
   */
  getDiff(timestamp) {
    return axios.get(`${BASE_URL}/diff_backup`, {
      params: { timestamp },
    });
  },

  /**
   * Lista logs de auditoria
   */
  getAuditLogs() {
    return axios.get(`${BASE_URL}/audit_logs`);
  },

  /**
   * Obtém status das credenciais
   */
  getCredentialsStatus() {
    return axios.get(`${BASE_URL}/credentials_status`);
  },

  /**
   * Migra credenciais do sistema legado
   */
  migrateCredentials() {
    return axios.post(`${BASE_URL}/migrate_credentials`);
  },

  /**
   * Envia mensagem para o chat AI
   * @param {string} message - Mensagem do usuario
   * @param {Object} context - Contexto da conversa
   * @param {string} context.current_scripts - Scripts atuais
   * @param {Array} context.chat_history - Historico do chat (ultimas 10 mensagens)
   */
  sendChatMessage(message, context) {
    return axios.post(`${BASE_URL}/chat`, {
      message,
      context,
    });
  },
};
